
import axiosClient from "apis/axios-client";
import { AxiosResponse } from "axios";

interface GetJackpotConfigurationParams {
    SearchWithName?: string;
    PageNumber?: number;
    PageSize?: number;
  }
  
  interface JackpotConfigDetails {
    createdDate: string;
    answer: number;
    validFrom: string;
    validTo: string;
    status: 'Active' | 'Disabled';
  }
  interface JackpotConfiguration {
    jackpotId: number;
    airlineId: number;
  }
  interface JackpotConfigAPI {
    configName: string;
    details: JackpotConfigDetails;
    configurations: JackpotConfiguration[];
  }
  interface JackpotConfigResponse {
    data: JackpotConfigAPI[];
    totalRecords: number;
  }
  
 
  export const getJackpotConfiguration = async (
    params: GetJackpotConfigurationParams = {}
  ): Promise<JackpotConfigResponse> => {
    try {
      const response = await axiosClient.get<JackpotConfigResponse>(
        '/admin/AdminCredit/GetJackpotConfiguration',
        {
          params: {
            SearchWithName: params.SearchWithName,
            PageNumber: params.PageNumber,
            PageSize: params.PageSize,
          },
        }
      )as unknown as JackpotConfigResponse;
      return response as JackpotConfigResponse;
    } catch (error) {
      console.error('Error fetching jackpot configuration:', error);
      throw error;
    }
  };
  
// Function to delete jackpot configurations by IDs
export const deleteJackpotConfiguration = async (ids: number[]): Promise<void> => {
  try {
    await axiosClient.delete('/admin/AdminCredit/DeleteJackpotConfiguration', {
      data: ids,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  } catch (error) {
    console.error('Error deleting jackpot configuration:', error);
    throw error;
  }
};
  
  // Define the interface for the configuration data
export interface JackpotConfigRequest {
    configurationName:string;
    airlineId: number[];
    answer: number;
    validFrom: string;
    validTo: string;
    isActive: boolean;
  }
  
  export interface JackpotConfigUpdate {
    jackpotId: number[];          // Changed to array
    airlineId: number[];
    configurationName:string;
    answer: number;
    validFrom: string;
    validTo: string;
    isActive: boolean;
  }

  interface JackpotConfigResponse {
    message: string;
    records: number;
  }
  
  // Define the response interface
  
  
  // The API call for Adding a New Jackpot Configuration
  export const addJackpotConfiguration = async (
    configData: JackpotConfigRequest
  ): Promise<JackpotConfigResponse> => {
    const endpoint = '/admin/AdminCredit/AddJackpotConfiguration';
   
  
    try {
      const response = await axiosClient.post<JackpotConfigResponse>(
        endpoint, 
        configData,
        
      )as unknown as JackpotConfigResponse; 
  
      return response;
      
    } catch (error: any) {
      console.error('Error in addJackpotConfiguration:', error);
      
      // Extract error message from backend response
      let errorMessage = 'Failed to add jackpot configuration';
      
      if (error.response) {
        // Backend returned an error response
        const errorData = error.response.data;
        errorMessage = errorData?.message || errorData?.detail || errorData?.error || errorMessage;
      } else if (error.message) {
        // Network or other error
        errorMessage = error.message;
      }
      
      throw new Error(errorMessage);
    }
  };
  



  export interface JackpotConfigUpdate {
    jackpotId: number[];
    airlineId: number[];
    configurationName: string;
    answer: number;
    validFrom: string;
    validTo: string;
    isActive: boolean;
  }
  interface ApiResponse {
    message: string;
  }
  
  export const updateJackpotConfiguration = async (config: JackpotConfigUpdate) => {
    try {
      const responseData = await axiosClient.post('/admin/AdminCredit/UpdateJackpotConfiguration', config, {
        headers: {
          'Content-Type': 'application/json',
        },
      })as ApiResponse; // No type assertion needed
      
      console.log('Response Data:', responseData); // Logs {"message":"Jackpot configuration updated successfully"}
  
      // Check the message property of the response object
      if (responseData?.message === "Jackpot configuration updated successfully.") {
        return { success: true };
      } else {
        return {
          success: false,
          error: responseData?.message || 'Failed to update jackpot configuration',
        };
      }
    } catch (error: any) {
      if (error.response) {
        const errorData = error.response.data;
        const errorMessage = errorData?.message || errorData?.detail || 'Failed to update jackpot configuration';
        return {
          success: false,
          error: errorMessage,
        };
      } else {
        return {
          success: false,
          error: 'An error occurred: ' + (error.message || 'Unknown error'),
        };
      }
    }
  };